// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-Hrz","discountPrice":"discountPrice-Nzh","price":"price-2Yy"};